import { ISMT_XemDeThi } from "../../model/respone/de-thi/ISMT_XemDeThi";
import { apiClient } from "../apiClient";
export const XEM_DE_THI_ENDPOINT = "xem-de-thi";

export const xemDeThiApi = {
  Select: (payload: ISMT_XemDeThi) =>
    apiClient.post(`${XEM_DE_THI_ENDPOINT}/select-by-id`, payload),
  ExportPdf: (payload: any) =>
    apiClient.post(`${XEM_DE_THI_ENDPOINT}/export-pdf`, payload),
  ExportAnswer: (payload: any) =>
    apiClient.post(`${XEM_DE_THI_ENDPOINT}/export-answer`, payload),
};
